<template>
  <div>
    <div v-loading="loading" class="order-detail">
      <!-- 顶部按钮 -->
      <div style="display: flex; justify-content: space-between; margin-bottom: 20px">
        <div>
          <el-button size="small" @click="handleBack">{{ $t("components.DialogSolve.303592-0") }}</el-button>
        </div>
        <div>
          <template v-if="mode != 3">
            <template
              v-if="
                (orderDetail.handleStatus === 0 &&
                  (orderDetail.reportStatus === 0 || orderDetail.reportStatus === 2)) ||
                (mode === 2 && orderDetail.handleStatus === 0)
              "
            >
              <el-button size="small" type="success" @click="showConfirmSolveDialog">
                {{ $t("components.DialogSolve.156255-23") }}
              </el-button>
              <el-button size="small" type="danger" @click="showConfirmCloseDialog">{{
                $t("components.DialogSolve.156255-27")
              }}</el-button>
            </template>

            <el-button
              size="small"
              type="primary"
              @click="reportProblem"
              v-if="
                mode === 1 &&
                (orderDetail.reportStatus === 0 || orderDetail.reportStatus === 2) &&
                orderDetail.handleStatus === 0
              "
              >{{ $t("components.DialogSolve.156255-28") }}</el-button
            >
            <el-button
              size="small"
              type="warning"
              @click="cancelReport"
              v-if="mode === 1 && orderDetail.reportStatus === 1 && orderDetail.handleStatus === 0"
              >{{ $t("components.DialogSolve.156255-29") }}</el-button
            >
          </template>
          <el-button
            v-if="mode === 3 && (orderDetail.handleStatus === 2 || orderDetail.handleStatus === -1)"
            size="small"
            type="danger"
            @click="handlerNotSolve"
            >{{ $t("components.DialogSolve.303592-2") }}</el-button
          >
          <el-button
            :loading="saveLoading"
            size="small"
            type="primary"
            @click="handlerEdit"
            v-if="orderDetail.handleStatus === 0"
            >{{ $t("components.DialogSolve.303592-1") }}
          </el-button>
        </div>
      </div>
      <div class="order-header">
        <div class="priority-container" style="display: flex; gap: 20px">
          <div>
            <span class="label">{{ $t("components.DialogSolve.303592-3") }}</span>
            <span>{{ orderDetail.orderNo }}</span>
          </div>
          <div>
            <span class="label">{{ $t("components.DialogSolve.156255-1") }}</span>
            <el-select
              v-model="orderDetail.priority"
              size="small"
              :disabled="handlerDisableChat()"
              style="width: 100px"
            >
              <el-option
                v-for="item in priorityList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </div>
          <div v-if="mode === 2">
            <span class="label">{{ $t("components.DialogSolve.303592-4") }}</span>
            <el-select
              v-model="orderDetail.agentIds"
              :collapse-tags="true"
              size="small"
              style="width: 250px"
              multiple
              filterable
              :placeholder="$t('components.DialogSolve.303592-5')"
            >
              <el-option v-for="item in adminList" :key="item.id" :value="item.id" :label="item.userName"></el-option>
            </el-select>
          </div>
        </div>

        <div class="steps-container">
          <el-steps :active="currentStep" finish-status="success" align-center>
            <el-step
              v-for="(step, index) in workOrderSteps"
              :key="index"
              :title="step.title"
              :description="step.description"
            >
            </el-step>
          </el-steps>
        </div>
      </div>

      <!-- 工单信息卡片 -->
      <div class="order-card">
        <div class="card-header">
          <span class="card-title">{{ $t("components.DialogSolve.303592-6") }}</span>
          <el-button type="text" @click="toggleOrderInfo">
            {{ orderInfoCollapsed ? $t("components.DialogSolve.303592-7") : $t("components.DialogSolve.303592-8") }}
            <i :class="orderInfoCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
          </el-button>
        </div>
        <div class="card-body" v-show="!orderInfoCollapsed">
          <div class="info-row">
            <div class="info-item">
              <span class="label">{{ $t("components.DialogSolve.156255-2") }}</span>
              <span class="value">{{ orderDetail.userName || $t("components.DialogSolve.156255-3") }}</span>
            </div>
            <div class="info-item">
              <span class="label">{{ $t("components.DialogSolve.156255-4") }}</span>
              <span class="value">{{ orderDetail.equipmentNo || $t("components.DialogSolve.156255-3") }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">{{ $t("components.DialogSolve.156255-5") }}</span>
              <span class="value">{{ orderDetail.equipmentName || $t("components.DialogSolve.156255-3") }}</span>
            </div>
            <div class="info-item">
              <span class="label">{{ $t("components.DialogSolve.156255-6") }}</span>
              <span class="value">{{ orderDetail.equipmentTypeName || $t("components.DialogSolve.156255-3") }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">{{ $t("components.DialogSolve.156255-7") }}</span>
              <span class="value">{{ orderDetail.user || $t("components.DialogSolve.156255-3") }}</span>
            </div>
            <div class="info-item">
              <span class="label">{{ $t("components.DialogSolve.156255-8") }}</span>
              <span class="value">{{ orderDetail.phone || $t("components.DialogSolve.156255-3") }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">{{ $t("components.DialogSolve.156255-9") }}</span>
              <span class="value">{{ orderDetail.email || $t("components.DialogSolve.156255-3") }}</span>
            </div>
            <div class="info-item">
              <span class="label">{{ $t("components.DialogSolve.156255-10") }}</span>
              <span class="value">{{ orderDetail.createTime || $t("components.DialogSolve.156255-3") }}</span>
            </div>
          </div>
          <div class="desc-title">{{ $t("components.DialogSolve.303592-9") }}</div>
          <div class="desc-content description-box">
            {{ orderDetail.description || $t("components.DialogSolve.156255-3") }}
          </div>
          <div v-if="orderDetail.fileUrls && orderDetail.fileUrls.length > 0">
            <div class="attachment-title">
              <span>{{ orderDetail.fileUrls.length }}{{ $t("components.DialogSolve.156255-13") }}</span>
            </div>
            <div class="attachment-list">
              <div v-for="(file, index) in orderDetail.fileUrls" :key="index" class="file-item">
                <i :class="getFileIconClass(file)"></i>
                <span class="file-name">{{ getFileName(file) }}</span>
                <el-button type="text" @click="previewFile(file)">{{
                  $t("components.DialogSolve.156255-14")
                }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 远程操作卡片 -->
      <div class="order-card" v-if="mode === 2">
        <div class="card-header">
          <div class="card-title">
            <span>{{ $t("components.DialogSolve.303592-10") }}</span>
            <span v-if="orderDetail.mqState === 1" class="online">{{ $t("components.DialogSolve.890533-0") }}</span>
            <span v-else class="offline">{{ $t("components.DialogSolve.890533-1") }}</span>
          </div>
          <el-button type="text" @click="toggleRemoteOperation">
            {{
              remoteOperationCollapsed ? $t("components.DialogSolve.303592-7") : $t("components.DialogSolve.303592-8")
            }}
            <i :class="remoteOperationCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
          </el-button>
        </div>
        <div class="card-body" v-show="!remoteOperationCollapsed">
          <el-button
            @click="handleControl()"
            size="mini"
            style="
              margin: 0 10px 10px 0;
              background-color: #ffbe6a;
              border: 0;
              color: #525252;
              font-weight: bold;
              padding: 7px;
              float: left;
            "
            >{{ $t("common.yckz") }}</el-button
          >
          <el-button
            @click="handleSendLogMQ(orderDetail.equipmentNo, 1)"
            size="mini"
            style="
              margin: 0 10px 10px 0;
              background-color: #c0ff53;
              border: 0;
              color: #525252;
              font-weight: bold;
              padding: 7px;
              float: left;
            "
            >{{ $t("common.kernelrz") }}</el-button
          >
          <el-button
            type="primary"
            @click="handleSendLogMQ(orderDetail.equipmentNo, 2)"
            size="mini"
            style="margin: 0 10px 10px 0; border: 0; font-weight: bold; padding: 7px; float: left"
            >{{ $t("common.dskgj") }}</el-button
          >
          <el-button
            type="primary"
            @click="handleSendLogMQ(orderDetail.equipmentNo, 3)"
            size="mini"
            style="margin: 0 10px 10px 0; border: 0; font-weight: bold; padding: 7px; float: left"
            >{{ $t("common.azrizhi") }}</el-button
          >
          <el-button
            type="danger"
            @click="handlerReStart(orderDetail.equipmentNo, '2')"
            size="mini"
            style="margin: 0 10px 10px 0; border: 0; font-weight: bold; padding: 7px; float: left"
            >{{ $t("user.MachineMaps.588934-2") }}</el-button
          >
          <el-button
            type="danger"
            @click="handlerReStart(orderDetail.equipmentNo, '1')"
            size="mini"
            style="margin: 0 10px 10px 0; border: 0; font-weight: bold; padding: 7px; float: left"
            >{{ $t("user.MachineMaps.588934-3") }}</el-button
          >
        </div>
      </div>

      <!-- 聊天记录卡片 -->
      <div class="chat-card">
        <div class="card-header">
          <span class="card-title">{{ $t("components.DialogSolve.303592-11") }}</span>
          <el-button type="text" @click="toggleChatRecord">
            {{ chatRecordCollapsed ? $t("components.DialogSolve.303592-7") : $t("components.DialogSolve.303592-8") }}
            <i :class="chatRecordCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
          </el-button>
        </div>
        <div class="card-body" v-show="!chatRecordCollapsed">
          <div class="chat-container" v-loading="msgLoading">
            <div class="chat-messages" ref="chatMessages">
              <div class="load-more-btn" @click="handlerLoadMore" v-if="page.pageIndex < totalPages">
                <i class="el-icon-refresh"></i> {{ $t("components.DialogSolve.303592-12") }}
              </div>
              <div class="load-more-btn load-more-disabled" v-else>{{ $t("components.DialogSolve.303592-13") }}</div>
              <div
                v-for="msg in sortedChatMessages"
                :key="msg.id"
                class="message-item"
                :class="{
                  'message-user': msg.senderType === 0,
                  'message-merchant': msg.senderType === 1,
                  'message-platform': msg.senderType === 2
                }"
              >
                <div class="message-avatar">
                  <el-avatar
                    :size="36"
                    :class="{
                      'avatar-user': msg.senderType === 0,
                      'avatar-merchant': msg.senderType === 1,
                      'avatar-platform': msg.senderType === 2
                    }"
                  >
                    {{ getSenderInitial(msg.senderType) }}
                  </el-avatar>
                </div>
                <div class="message-content">
                  <div class="message-info">
                    <span class="message-sender">{{ getSenderName(msg.senderType) }}</span>
                    <span class="message-time">{{ msg.createTime }}</span>
                  </div>
                  <div class="message-text" style="word-break: break-all">{{ msg.message }}</div>
                  <!-- 添加附件显示 -->
                  <div v-if="msg.fileUrls && msg.fileUrls.length > 0" class="message-attachments">
                    <div v-for="(file, fileIndex) in msg.fileUrls" :key="fileIndex" class="message-attachment">
                      <i :class="getFileIconClass(file)"></i>
                      <span class="file-name">{{ getFileName(file) }}</span>
                      <el-button type="text" size="mini" @click="previewFile(file)">{{
                        $t("components.DialogSolve.303592-14")
                      }}</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="no-message" v-if="chatMessages.length === 0">
                {{ $t("components.DialogSolve.303592-15") }}
              </div>
            </div>
            <div class="chat-input-area">
              <div v-if="handlerDisableChat()" class="chat-input-area-disabled">
                {{ $t("components.DialogSolve.303592-16") }}
              </div>
              <div class="upload-button" style="position: relative">
                <div v-if="uploadLoading" style="top: 0; right: 0; bottom: 0; left: 0; position: absolute"></div>
                <el-upload
                  :auto-upload="false"
                  :before-upload="handlerBeforeUpload"
                  :on-change="handleFileChange"
                  :on-remove="handleFileRemove"
                  :file-list="fileList"
                  :limit="2"
                  ref="upload"
                >
                  <el-button :loading="uploadLoading" icon="el-icon-paperclip" size="small">
                    <template v-if="uploadLoading">{{ $t("components.DialogSolve.421203-0") }}</template>
                    <template v-else>
                      {{ $t("components.DialogSolve.303592-17") }}
                    </template>
                  </el-button>
                </el-upload>
                <div style="color: #666; font-size: 12px">{{ $t("components.DialogSolve.421203-1") }}</div>
              </div>
              <div class="chat-input-container">
                <el-input
                  type="textarea"
                  v-model="messageText"
                  :rows="3"
                  :placeholder="$t('components.DialogSolve.303592-18')"
                  class="chat-input"
                ></el-input>
                <el-button type="primary" @click="sendMessage" :disabled="!messageText.trim() || uploadLoading">
                  {{ $t("components.DialogSolve.303592-19") }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 用户的评级 -->
      <div
        class="problem-desc"
        v-if="(orderDetail.handleStatus === 2 || orderDetail.handleStatus === -1) && orderDetail.rating !== null"
      >
        <div class="desc-title">{{ $t("components.DialogSolve.156255-15") }}</div>
        <el-rate disabled v-model="orderDetail.rating"></el-rate>
        <div style="margin-top: 10px; word-break: break-all" v-if="orderDetail.ratingContent">
          <div class="desc-title">
            {{ $t("components.DialogSolve.156255-16") }}
          </div>
          <div>
            {{ orderDetail.ratingContent }}
          </div>
        </div>
      </div>
      <!-- 已解决 -->
      <div class="problem-desc" v-if="orderDetail.handleStatus === 2">
        <div class="desc-title">{{ $t("components.DialogSolve.303592-20") }}</div>
        <div style="margin-top: 4px; word-break: break-all" v-if="orderDetail.resolution">
          {{ orderDetail.resolution }}
        </div>
      </div>
      <!-- 已关闭 -->
      <div class="problem-desc" v-if="orderDetail.handleStatus === -1">
        <div class="desc-title">{{ $t("components.DialogSolve.303592-21") }}</div>
        <div style="margin-top: 4px; word-break: break-all" v-if="orderDetail.resolution">
          {{ orderDetail.resolution }}
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <el-dialog
      :title="$t('components.DialogSolve.156255-17')"
      :visible.sync="imagePreviewVisible"
      append-to-body
      width="70%"
      :close-on-click-modal="true"
    >
      <div class="image-preview-container">
        <img :src="previewUrl" :alt="$t('components.DialogSolve.156255-18')" class="preview-image" />
      </div>
    </el-dialog>

    <!-- 视频预览弹窗 -->
    <el-dialog
      :title="$t('components.DialogSolve.156255-19')"
      :visible.sync="videoPreviewVisible"
      append-to-body
      width="70%"
      :close-on-click-modal="true"
    >
      <div class="video-preview-container">
        <video :src="previewUrl" controls autoplay class="preview-video"></video>
      </div>
    </el-dialog>

    <!-- 确认解决弹窗 -->
    <el-dialog
      :title="$t('components.DialogSolve.156255-20')"
      :visible.sync="confirmSolveDialogVisible"
      append-to-body
      width="30%"
      :close-on-click-modal="false"
    >
      <div class="confirm-solve-content">
        <el-input
          type="textarea"
          v-model="resolution"
          :rows="5"
          :placeholder="$t('components.DialogSolve.156255-21')"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmSolveDialogVisible = false">{{ $t("components.DialogSolve.156255-22") }}</el-button>
        <el-button type="primary" @click="submitSolve">{{ $t("components.DialogSolve.156255-23") }}</el-button>
      </span>
    </el-dialog>

    <!-- 确认关闭工单弹窗 -->
    <el-dialog
      :title="$t('components.DialogSolve.156255-24')"
      :visible.sync="confirmCloseDialogVisible"
      append-to-body
      width="30%"
      :close-on-click-modal="false"
    >
      <div class="confirm-close-content">
        <el-input
          type="textarea"
          v-model="resolution"
          :rows="5"
          :placeholder="$t('components.DialogSolve.156255-25')"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmCloseDialogVisible = false">{{ $t("components.DialogSolve.156255-22") }}</el-button>
        <el-button type="primary" @click="submitClose">{{ $t("components.DialogSolve.156255-26") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "DialogSolve",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      orderId: {
        type: String,
        default: ""
      },
      priorityList: {
        type: Array,
        default: () => []
      },
      mode: {
        type: Number,
        default: 1 //1 工单管理 2 平台工单 3我的工单
      }
    },
    data() {
      return {
        workOrderSteps: [
          {
            title: this.$t("components.DialogSolve.156255-30"),
            description: this.$t("components.DialogSolve.156255-31")
          },
          {
            title: this.$t("components.DialogSolve.546941-0"),
            description: this.$t("components.DialogSolve.546941-1")
          },
          {
            title: this.$t("components.DialogSolve.156255-34"),
            description: this.$t("components.DialogSolve.156255-35")
          }
        ],
        dialogVisible: false,
        loading: false,
        currentStep: 0,
        orderDetail: {
          id: "",
          orderNo: "",
          type: 1,
          questionType: -1,
          handleStatus: 1,
          reportStatus: 0,
          priority: 0,
          description: "",
          user: "",
          phone: "",
          email: "",
          equipmentNo: "",
          equipmentName: "",
          equipmentTypeName: "",
          fileUrls: []
        },
        // 附件预览相关
        imagePreviewVisible: false,
        videoPreviewVisible: false,
        previewUrl: "",
        resolution: "",
        // 新增确认弹窗
        confirmSolveDialogVisible: false,
        confirmCloseDialogVisible: false,
        msgLoading: false,
        // 新增聊天相关
        chatMessages: [],
        messageText: "",
        // 折叠状态
        orderInfoCollapsed: false,
        chatRecordCollapsed: false,
        remoteOperationCollapsed: false,
        fileList: [],
        // 滚动位置记录
        scrollPosition: null,
        totalPages: 1,
        page: {
          pageIndex: 1,
          pageSize: 10
        },
        // 远程控制相关数据
        control: {
          remoteCode: "",
          remoteId: "",
          remoteStatus: 0,
          url: ""
        },
        // 远程控制轮询计数与缓存
        countError: 0,
        nowRemoteInfo: {},
        showPositions: [],
        adminList: [],
        saveLoading: false,
        uploadLoading: false
      };
    },
    computed: {
      sortedChatMessages() {
        // 对消息记录按创建时间正序排列（从旧到新）
        return [...this.chatMessages].sort((a, b) => {
          return new Date(a.createTime) - new Date(b.createTime);
        });
      }
    },
    mounted() {
      this.fetchOrderDetail();
      this.fetchMsgRecord();
      if (this.mode === 2) {
        this.fetchAdminList();
      }
    },
    methods: {
      //订单是否已完成 完成并不代表已评分
      handlerDisableChat() {
        if (this.orderDetail.handleStatus == 2 || this.orderDetail.handleStatus == -1) {
          return true;
        }
        return false;
      },
      handlerNotSolve() {
        this.$confirm(this.$t("components.DialogSolve.303592-22"), this.$t("components.DialogSolve.303592-23"), {
          confirmButtonText: this.$t("components.DialogSolve.303592-24"),
          cancelButtonText: this.$t("components.DialogSolve.303592-25"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.WorkOrder.notSolve, this.$method.put, {
              id: this.orderId
            })
            .then(res => {
              if (res.code === 0) {
                this.$emit("refresh");
                this.$message.success(this.$t("components.DialogSolve.303592-26"));
                this.orderDetail.handleStatus = 0;
              } else {
                this.$message.warning(res.msg);
              }
            });
        });
      },
      handlerEdit() {
        this.saveLoading = true;
        this.$api
          .request(this.$url.WorkOrder.edit, this.$method.put, {
            id: this.orderId,
            userEquipmentId: this.orderDetail.userEquipmentId,
            priority: this.orderDetail.priority,
            agentIds: this.orderDetail.agentIds
          })
          .then(res => {
            if (res.code === 0) {
              this.$message.success(this.$t("components.DialogSolve.303592-26"));
              this.$emit("refresh");
            } else {
              this.$message.warning(res.msg);
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      },
      fetchAdminList() {
        this.$api.request(this.$url.WorkOrder.adminList, this.$method.get).then(res => {
          if (res.code === 0 && res.data) {
            this.adminList = res.data;
          }
        });
      },
      // 滚动到底部
      scrollToBottom() {
        if (this.$refs.chatMessages) {
          this.$nextTick(() => {
            const container = this.$refs.chatMessages;
            container.scrollTop = container.scrollHeight;
          });
        }
      },
      //滚动到旧位置
      // 保存当前滚动位置
      saveScrollPosition() {
        if (this.$refs.chatMessages) {
          const container = this.$refs.chatMessages;
          // 保存第一条可见消息的位置信息
          this.scrollPosition = {
            scrollHeight: container.scrollHeight,
            scrollTop: container.scrollTop
          };
        }
      },

      // 恢复到之前的滚动位置
      scrollToOldPos() {
        if (this.$refs.chatMessages) {
          this.$nextTick(() => {
            const container = this.$refs.chatMessages;
            if (this.scrollPosition) {
              // 计算新内容增加的高度
              const heightDiff = container.scrollHeight - this.scrollPosition.scrollHeight;
              // 将滚动位置调整为原位置加上新增加的高度，这样可以保持视图相对位置不变
              container.scrollTop = this.scrollPosition.scrollTop + heightDiff;
            }
          });
        }
      },
      // 折叠/展开工单信息
      toggleOrderInfo() {
        this.orderInfoCollapsed = !this.orderInfoCollapsed;
      },
      // 折叠/展开远程操作
      toggleRemoteOperation() {
        this.remoteOperationCollapsed = !this.remoteOperationCollapsed;
      },
      // 折叠/展开聊天记录
      toggleChatRecord() {
        this.chatRecordCollapsed = !this.chatRecordCollapsed;
        if (!this.chatRecordCollapsed) {
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      },
      // 发送消息
      sendMessage() {
        this.msgLoading = true;
        // 处理文件上传
        const fileUrls = this.fileList.map(file => file.url || "");

        this.$api
          .request(this.$url.WorkOrder.sendMsg, this.$method.post, {
            workOrderId: this.orderId,
            message: this.messageText,
            fileUrls: fileUrls
          })
          .then(res => {
            if (res.code === 0) {
              this.messageText = "";
              this.fileList = [];
              // 发送成功后立即刷新消息列表
              this.fetchMsgRecord();
            } else {
              this.$message.error(res.msg || this.$t("components.DialogSolve.303592-27"));
            }
          })
          .catch(() => {
            this.$message.error(this.$t("components.DialogSolve.303592-27"));
          })
          .finally(() => {
            this.msgLoading = false;
          });
      },
      handlerBeforeUpload() {
        if (this.fileList.length > 2) {
          this.$message.warning(this.$t("components.DialogSolve.421203-2"));
          return false;
        }
      },
      // 处理文件变更
      handleFileChange(file, fileList) {
        this.fileList = fileList;

        // 如果文件没有URL，需要上传文件获取URL
        if (file && !file.url) {
          this.uploadFile(file);
        }
      },
      // 处理文件删除
      handleFileRemove(file, fileList) {
        this.fileList = fileList;
      },
      // 上传文件
      uploadFile(file) {
        const formData = new FormData();
        const rawFile = file.raw || file;
        const isVideo =
          (rawFile && rawFile.type && rawFile.type.startsWith("video")) ||
          (rawFile && rawFile.name && /\.mp4$/i.test(rawFile.name));
        const uploadUrl = isVideo ? this.$url.WorkOrder.uploadVideo : this.$url.WorkOrder.uploadImg;
        formData.append("file", rawFile);
        this.uploadLoading = true;
        this.$api
          .request(uploadUrl, this.$method.post, formData)
          .then(res => {
            if (res.code === 0 && res.data) {
              // 更新文件列表中对应文件的URL
              const index = this.fileList.findIndex(item => item.uid === file.uid);
              if (index !== -1) {
                this.$set(this.fileList[index], "url", res.data);
              }
            } else {
              this.$message.error(res.msg || this.$t("components.DialogSolve.303592-28"));
              // 移除上传失败的文件
              this.fileList = this.fileList.filter(item => item.uid !== file.uid);
            }
          })
          .catch(() => {
            this.$message.error(this.$t("components.DialogSolve.303592-28"));
            this.fileList = this.fileList.filter(item => item.uid !== file.uid);
          })
          .finally(() => {
            this.uploadLoading = false;
          });
      },
      //获取消息记录
      fetchMsgRecord() {
        this.msgLoading = true;
        this.$api
          .request(this.$url.WorkOrder.getMsg, this.$method.get, { workOrderId: this.orderId, ...this.page })
          .then(res => {
            if (res.code === 0 && res.data && res.data.current == 1) {
              this.chatMessages = res.data.records || [];
              this.totalPages = parseInt(res.data.pages) || 1;
              this.$nextTick(() => {
                this.scrollToBottom();
              });
            } else if (res.code === 0 && res.data) {
              this.chatMessages = [...this.chatMessages, ...res.data.records];
              this.totalPages = parseInt(res.data.pages) || 1;
              this.scrollToOldPos();
            } else if (res.code !== 0) {
              console.error(res.msg);
            }
          })
          .finally(() => {
            this.msgLoading = false;
          });
      },
      handlerLoadMore() {
        // 在加载更多消息前保存当前滚动位置
        this.saveScrollPosition();
        this.page.pageIndex++;
        this.fetchMsgRecord();
      },
      handleBack() {
        this.$emit("close");
      },
      handleClose() {
        this.orderDetail = {
          id: "",
          orderNo: "",
          type: 1,
          questionType: 1,
          handleStatus: -1,
          reportStatus: 1,
          priority: 0,
          description: "",
          user: "",
          phone: "",
          email: "",
          equipmentNo: "",
          equipmentName: "",
          equipmentTypeName: "",
          fileUrls: []
        };
        this.currentStep = 0;
        this.resolution = "";
      },
      fetchOrderDetail() {
        this.loading = true;
        this.$api
          .request(this.$url.WorkOrder.getDetail, this.$method.get, { id: this.orderId })
          .then(res => {
            if (res.code === 0 && res.data) {
              this.orderDetail = res.data;
              // 根据工单状态设置当前步骤
              if (
                (this.orderDetail.handleStatus === 2 || this.orderDetail.handleStatus === -1) &&
                this.orderDetail.rating === null
              ) {
                this.currentStep = 2;
              } else if (this.orderDetail.rating !== null) {
                this.currentStep = 3;
              } else {
                this.currentStep = 0;
              }
            } else {
              this.$message.error(res.msg || this.$t("components.DialogSolve.156255-36"));
            }
            this.loading = false;
          })
          .catch(err => {
            console.error(this.$t("components.DialogSolve.156255-37"), err);
            this.$message.error(this.$t("components.DialogSolve.156255-36"));
            this.loading = false;
          });
      },
      getFileIconClass(fileUrl) {
        const ext = this.getFileExtension(fileUrl);
        if (["jpg", "jpeg", "png", "gif"].includes(ext)) {
          return "el-icon-picture";
        } else if (ext === "mp4") {
          return "el-icon-video-camera";
        } else {
          return "el-icon-document";
        }
      },
      getFileExtension(fileUrl) {
        const match = fileUrl.match(/\.([^.]+)$/);
        return match ? match[1].toLowerCase() : "";
      },
      getFileName(fileUrl) {
        const parts = fileUrl.split("/");
        return parts[parts.length - 1];
      },
      previewFile(fileUrl) {
        const ext = this.getFileExtension(fileUrl);
        this.previewUrl = fileUrl;

        if (["jpg", "jpeg", "png", "gif"].includes(ext)) {
          // 预览图片
          this.imagePreviewVisible = true;
          this.videoPreviewVisible = false;
        } else if (ext === "mp4") {
          // 预览视频
          this.imagePreviewVisible = false;
          this.videoPreviewVisible = true;
        } else {
          // 其他类型文件直接下载
          window.open(fileUrl, "_blank");
        }
      },
      downloadFile(fileUrl) {
        window.open(fileUrl, "_blank");
      },
      downloadAll() {
        this.orderDetail.fileUrls.forEach(fileUrl => {
          this.downloadFile(fileUrl);
        });
      },
      // 显示确认解决弹窗
      showConfirmSolveDialog() {
        this.resolution = "";
        this.confirmSolveDialogVisible = true;
      },
      // 显示确认关闭弹窗
      showConfirmCloseDialog() {
        this.resolution = "";
        this.confirmCloseDialogVisible = true;
      },
      // 提交解决
      submitSolve() {
        // 这里调用确认解决接口
        this.$api
          .request(this.$url.WorkOrder.solve, this.$method.put, { id: this.orderId, resolution: this.resolution })
          .then(res => {
            if (res.code === 0) {
              this.$message.success(this.$t("components.DialogSolve.156255-38"));
              this.currentStep = 1;
              this.orderDetail.handleStatus = 2;
              this.orderDetail.resolution = this.resolution;
              this.confirmSolveDialogVisible = false;
              this.$emit("close");
              this.$emit("refresh");
            } else {
              this.$message.error(res.msg || this.$t("components.DialogSolve.156255-39"));
            }
          })
          .catch(() => {
            this.$message.error(this.$t("components.DialogSolve.156255-39"));
          });
      },
      // 提交关闭
      submitClose() {
        // 这里调用关闭工单接口
        this.$api
          .request(this.$url.WorkOrder.close, this.$method.put, { id: this.orderId, resolution: this.resolution })
          .then(res => {
            if (res.code === 0) {
              this.$message.success(this.$t("components.DialogSolve.156255-40"));
              this.confirmCloseDialogVisible = false;
              this.dialogVisible = false;
              this.$emit("close");
              this.$emit("refresh");
            } else {
              this.$message.error(res.msg || this.$t("components.DialogSolve.156255-39"));
            }
          })
          .catch(() => {
            this.$message.error(this.$t("components.DialogSolve.156255-39"));
          });
      },
      reportProblem() {
        this.$confirm(this.$t("components.DialogSolve.156255-41"), this.$t("components.DialogSolve.156255-42"), {
          confirmButtonText: this.$t("components.DialogSolve.156255-43"),
          cancelButtonText: this.$t("components.DialogSolve.156255-22"),
          type: "info"
        })
          .then(() => {
            // 这里调用上报接口
            this.$api
              .request(this.$url.WorkOrder.report, this.$method.put, { id: this.orderId })
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t("components.DialogSolve.156255-44"));
                  this.orderDetail.reportStatus = 1;
                  this.$emit("refresh");
                } else {
                  this.$message.error(res.msg || this.$t("components.DialogSolve.156255-39"));
                }
              })
              .catch(() => {
                this.$message.error(this.$t("components.DialogSolve.156255-39"));
              });
          })
          .catch(() => {});
      },
      cancelReport() {
        this.$confirm(this.$t("components.DialogSolve.156255-45"), this.$t("components.DialogSolve.156255-42"), {
          confirmButtonText: this.$t("components.DialogSolve.156255-43"),
          cancelButtonText: this.$t("components.DialogSolve.156255-22"),
          type: "warning"
        })
          .then(() => {
            // 这里调用取消上报接口
            this.$api
              .request(this.$url.WorkOrder.cancelReport, this.$method.put, { id: this.orderId })
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t("components.DialogSolve.156255-46"));
                  this.orderDetail.reportStatus = 2;
                  this.$emit("refresh");
                } else {
                  this.$message.error(res.msg || this.$t("components.DialogSolve.156255-39"));
                }
              })
              .catch(() => {
                this.$message.error(this.$t("components.DialogSolve.156255-39"));
              });
          })
          .catch(() => {});
      },
      // 获取发送者名称
      getSenderName(senderType) {
        switch (senderType) {
          case 0:
            return this.$t("components.DialogSolve.303592-29");
          case 1:
            return this.$t("components.DialogSolve.303592-30");
          case 2:
            return this.$t("components.DialogSolve.303592-31");
          default:
            return this.$t("components.DialogSolve.303592-32");
        }
      },
      // 获取发送者头像显示字母
      getSenderInitial(senderType) {
        switch (senderType) {
          case 0:
            return this.$t("components.DialogSolve.303592-33");
          case 1:
            return this.$t("components.DialogSolve.303592-34");
          case 2:
            return this.$t("components.DialogSolve.303592-35");
          default:
            return "?";
        }
      },

      // 发送日志 MQTT 消息
      handleSendLogMQ(equipmentNo, type) {
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.xiazload"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        this.$api
          .request(this.$url.UserMachine.sendMqtt, this.$method.post, {
            equipmentNo,
            type
          })
          .then(res => {
            if (res.code == 0) {
              this.actionQuery(equipmentNo, type, loading);
            } else {
              this.$notify({
                title: this.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            this.$notify({
              title: this.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },

      // 查询日志状态
      actionQuery(equipmentNo, type, loading) {
        let _self = this;
        _self.$api
          .request(_self.$url.UserMachine.androidlog, _self.$method.get, {
            equipmentNo,
            type
          })
          .then(res => {
            if (res.code == 0) {
              let records = res.data.records;
              loading.close();
              if (records.length > 0) {
                let url = records[0]["url"];
                window.location.href = url;
              } else {
                _self.$notify({
                  title: _self.$t("common.tip"),
                  message: _self.$t("common.xzcsl"),
                  type: "warning"
                });
              }
            } else if (res.code == 1) {
              // 下载中
              let djs = setTimeout(function () {
                clearTimeout(djs);
                _self.actionQuery(equipmentNo, type, loading);
              }, 3000);
            } else {
              loading.close();
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            this.$notify({
              title: this.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },

      // 重启板子功能
      async handlerReStart(equipmentNo, type) {
        await this.$confirm(
          type === "2" ? this.$t("user.MachineMaps.588934-5") : this.$t("user.MachineMaps.588934-6"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        );
        this.$api
          .request(this.$url.UserMachine.reStartBoard, this.$method.post, {
            equipmentNo,
            type
          })
          .then(res => {
            this.$notify({
              title: this.$t("common.tip"),
              message: res.msg,
              type: res.code === 0 ? "success" : "warning"
            });
          })
          .catch(() => {
            this.$notify({
              title: this.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },
      //  监听远程控制连接状态（对齐 MachineMaps 逻辑）
      async getYCKZControl(equipmentNo, loading) {
        let _self = this;

        await this.delay(3000);
        // 调用一次 ++
        this.countError++;
        if (this.countError > 20) {
          this.$message.warning(this.$t("user.MachineMaps.588934-10"));
          loading.close();
          // 若已有历史连接信息，则兜底使用旧链接
          if (!(this.nowRemoteInfo.remoteCode && this.nowRemoteInfo.remoteId && this.nowRemoteInfo.gotoHttpUrl)) {
            return;
          }
          this.control.remoteCode = this.nowRemoteInfo.remoteCode;
          this.control.remoteId = this.nowRemoteInfo.remoteId;
          this.control.url = this.nowRemoteInfo.gotoHttpUrl;
          const form = document.createElement("form");
          form.method = "post";
          form.action = this.control.url;
          form.target = "_blank";
          const createInput = (name, value) => {
            const input = document.createElement("input");
            input.name = name;
            input.value = value;
            form.appendChild(input);
          };
          createInput("c", this.control.remoteId);
          createInput("pass", this.control.remoteCode);
          createInput("dn", localStorage.getItem("isReyeah") ? "Reyeah" : "Vending");
          createInput("lang", "0");
          document.body.appendChild(form);
          form.submit();
          document.body.removeChild(form);
          return;
        }

        _self.$api
          .request(_self.$url.UserMachine.getcontrol, _self.$method.get, {
            equipmentNo
          })
          .then(res => {
            if (res.code == 0) {
              if (res.data && res.data.remoteState == 2) {
                loading.close();
                //  连接成功
                _self.control.remoteCode = res.data.remoteCode;
                _self.control.remoteId = res.data.remoteId;
                _self.control.url = res.data.gotoHttpUrl;
                const form = document.createElement("form");
                form.method = "post";
                form.action = _self.control.url;
                form.target = "_blank";
                const createInput = (name, value) => {
                  const input = document.createElement("input");
                  input.name = name;
                  input.value = value;
                  form.appendChild(input);
                };
                createInput("c", _self.control.remoteId);
                createInput("pass", _self.control.remoteCode);
                createInput("dn", localStorage.getItem("isReyeah") ? "Reyeah" : "Vending");
                createInput("lang", "0");
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
                return;
              } else if (res.data && res.data.remoteState == -1) {
                loading.close();
                //  连接失败
                _self.$notify({
                  title: _self.$t("common.tip"),
                  message: _self.$t("common.ljfail"),
                  type: "error"
                });
              } else {
                //  连接中，继续轮询
                let djs = setTimeout(function () {
                  clearTimeout(djs);
                  _self.getYCKZControl(equipmentNo, loading);
                }, 1000);
              }
            } else {
              loading.close();
              //  连接失败
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(res => {
            loading.close();
            //  连接失败
            _self.$notify({
              title: _self.$t("common.tip"),
              message: JSON.stringify(res),
              type: "error"
            });
          });
      },

      // 远程控制
      handleControl() {
        let _self = this;
        this.nowRemoteInfo = this.orderDetail || {};
        // 直接远程控制
        const loading = _self.$loading({
          lock: true,
          text: _self.$t("common.ljload"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });

        _self.$api
          .request(_self.$url.UserMachine.control, _self.$method.post, {
            equipmentNo: this.orderDetail.equipmentNo
          })
          .then(res => {
            if (res.code == 0) {
              // 还原次数
              _self.countError = 0;
              //  监听远程控制连接状态
              _self.getYCKZControl(this.orderDetail.equipmentNo, loading);
            } else {
              loading.close();
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            loading.close();
            _self.$notify({
              title: _self.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },
      // 延迟函数
      async delay(time) {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, time);
        });
      },

      // 设备开锁功能
      handleUnlocking() {
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.xiazload"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });

        this.$api
          .request(this.$url.UserMachine.sendMqtt, this.$method.post, {
            topic: this.orderDetail.equipmentNo,
            message: "UNLOCK",
            type: "UNLOCK"
          })
          .then(res => {
            loading.close();
            if (res.code == 0) {
              this.$notify({
                title: this.$t("common.tip"),
                message: this.$t("common.succeed"),
                type: "success"
              });
            } else {
              this.$notify({
                title: this.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            loading.close();
            this.$notify({
              title: this.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .order-detail {
    padding: 16px;
    border-radius: 4px;
  }

  .order-header {
    margin-bottom: 24px;
  }

  .priority-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .priority-container .label {
    margin-right: 10px;
    font-weight: 500;
  }

  .steps-container {
    margin: 30px 0;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  }

  // 卡片样式
  .order-card,
  .chat-card {
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    overflow: hidden;
    transition: all 0.3s;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #ebeef5;
    background-color: #f5f7fa;
  }

  .card-title {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
  }

  .card-body {
    padding: 16px;
    transition: all 0.3s;
  }

  .info-row {
    display: flex;
    margin-bottom: 15px;
  }

  .info-item {
    flex: 1;
    display: flex;
  }

  .info-item .label {
    color: #606266;
    width: 100px;
    text-align: right;
    margin-right: 10px;
    font-weight: 500;
  }

  .info-item .value {
    color: #333;
    flex: 1;
  }

  // 聊天区域样式
  .chat-container {
    display: flex;
    flex-direction: column;
  }

  .chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 4px;
    margin-bottom: 12px;
    max-height: 600px;
    min-height: 200px;
  }

  .chat-input-area {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 4px;
    padding: 8px 0;
    border-top: 1px solid #f0f0f0;
    position: relative;
  }
  .chat-input-area-disabled {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 20px;
  }

  .upload-button {
    padding: 0 10px 8px;
    border-bottom: 1px dashed #f0f0f0;
    margin-bottom: 8px;
  }

  .chat-input-container {
    display: flex;
    align-items: flex-end;
    padding: 0 10px;
  }

  .chat-input {
    flex: 1;
    margin-right: 10px;
  }

  .message-item {
    display: flex;
    margin-bottom: 20px;

    &.message-user {
      .message-content {
        background-color: #ffffff;
        border-radius: 8px;
        border: 1px solid #e6e6e6;
      }

      .message-info {
        .message-sender {
          color: #303133;
        }
      }
    }

    &.message-merchant {
      .message-content {
        background-color: #f0f9eb;
        border-radius: 8px;
        border: 1px solid #e1f3d8;
      }

      .message-info {
        .message-sender {
          color: #67c23a;
        }
      }
    }

    &.message-platform {
      .message-content {
        background-color: #ecf5ff;
        border-radius: 8px;
        border: 1px solid #d9ecff;
      }

      .message-info {
        .message-sender {
          color: #409eff;
        }
      }
    }
  }

  .avatar-user {
    background-color: #909399;
  }

  .avatar-merchant {
    background-color: #67c23a;
  }

  .avatar-platform {
    background-color: #409eff;
  }

  .message-content {
    flex: 1;
    margin-left: 12px;
    padding: 10px;
    background-color: #fff;
    border-radius: 0 8px 8px 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    max-width: 80%;
  }

  .message-avatar {
    flex-shrink: 0;
  }

  .message-info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  .message-sender {
    font-weight: bold;
    color: #303133;
    font-size: 14px;
  }

  .message-time {
    color: #909399;
    font-size: 12px;
  }

  .message-text {
    color: #606266;
    word-break: break-word;
    line-height: 1.6;
  }

  .message-attachments {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
  }

  .message-attachment {
    display: flex;
    align-items: center;
    padding: 4px 0;

    i {
      margin-right: 5px;
      font-size: 16px;
      color: #409eff;
    }

    .file-name {
      flex: 1;
      font-size: 13px;
      color: #606266;
      margin-right: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .load-more-btn {
    text-align: center;
    padding: 8px 0;
    margin: 8px 0;
    background-color: #f5f7fa;
    border-radius: 4px;
    color: #409eff;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.3s;
    border: 1px solid #e6e6e6;
  }

  .load-more-btn:hover {
    background-color: #ecf5ff;
    color: #66b1ff;
  }

  .load-more-btn.load-more-disabled {
    background-color: #f5f5f5;
    color: #909399;
    cursor: default;
    border: 1px solid #ebeef5;
  }

  .load-more-btn.load-more-disabled:hover {
    background-color: #f5f5f5;
    color: #909399;
  }

  .no-message {
    text-align: center;
    color: #909399;
    padding: 60px 0;
    font-size: 14px;
  }

  .problem-desc {
    margin: 20px 0;
    padding: 15px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  }

  .desc-title {
    font-weight: bold;
    margin-bottom: 10px;
    color: #303133;
  }

  .desc-content {
    white-space: pre-wrap;
    word-break: break-all;
    line-height: 1.6;
  }

  .description-box {
    padding: 12px 15px;
    background-color: #f9f9f9;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    margin: 10px 0 15px 0;
    min-height: 60px;
    color: #606266;
    font-size: 14px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .attachment-section {
    margin: 20px 0;
    padding: 15px;
    background-color: #f8f8f8;
    border-radius: 4px;
  }

  .attachment-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px 0;
    font-weight: bold;
    color: #303133;
  }

  .attachment-list {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 10px;
    background-color: #fff;
  }

  .file-item {
    display: flex;
    align-items: center;
    padding: 8px 5px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.3s;
  }

  .file-item:last-child {
    border-bottom: none;
  }

  .file-item:hover {
    background-color: #f5f7fa;
  }

  .file-item i {
    margin-right: 8px;
    font-size: 20px;
    color: #409eff;
  }

  .file-item i.el-icon-picture {
    color: #67c23a;
  }

  .file-item i.el-icon-video-camera {
    color: #e6a23c;
  }

  .file-name {
    flex: 1;
    margin-right: 10px;
    word-break: break-all;
    color: #303133;
    font-size: 14px;
  }

  .file-upload-container {
    width: 100%;
  }

  ::v-deep .el-upload-list {
    max-height: 120px;
    overflow-y: auto;
    margin-top: 8px;
    padding: 0 10px;
  }

  ::v-deep .el-upload-list__item {
    margin-top: 5px;
    padding: 5px;
    transition: all 0.3s;
  }

  ::v-deep .el-upload-list__item:hover {
    background-color: #f5f7fa;
  }

  /* 自定义确认弹窗样式 */
  ::v-deep .confirm-dialog {
    .el-dialog__header {
      background-color: #f5f5f5;
    }

    .el-dialog__body {
      padding: 30px;
      background-color: #f5f5f5;
    }

    .el-textarea__inner {
      background-color: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
    }
  }

  /* 附件预览样式 */
  .image-preview-container,
  .video-preview-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 4px;
  }

  .preview-image {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  .preview-video {
    width: 100%;
    max-height: 70vh;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  /* 按钮样式优化 */
  ::v-deep .el-dialog__footer .dialog-footer .el-button {
    padding: 9px 15px;
  }

  ::v-deep .el-dialog__header {
    padding: 15px 20px;
    border-bottom: 1px solid #f0f0f0;
  }

  ::v-deep .el-dialog__body {
    padding: 20px 20px;
  }

  ::v-deep .el-dialog__footer {
    padding: 15px 20px;
    border-top: 1px solid #f0f0f0;
  }
  .online {
    font-size: 12px;
    margin-left: 10px;
    color: #67c23a;
    &::before {
      content: "";
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #67c23a;
      margin-right: 2px;
    }
  }
  .offline {
    font-size: 12px;
    margin-left: 10px;
    color: #f56c6c;
    &::before {
      content: "";
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #f56c6c;
      margin-right: 2px;
    }
  }
</style>
